import { Component, computed, inject, input } from '@angular/core';

import {
  ModalSectionKey,
  type IModalContext,
  type IModalData,
} from '../../../modal.interface';
import { ModalService } from '../../../modal.service';

@Component({ template: 'myre-modal-section' })
export abstract class ModalSectionComponent<D = Record<string, unknown>> {
  private _modalService = inject(ModalService);

  protected abstract _name: ModalSectionKey;

  protected uid = input.required<string>();

  protected modalRef = computed<IModalData>(() => {
    return this._modalService.getModal(this.uid());
  });

  protected data = computed<D>(() => {
    return (this.modalRef()?.[this._name]?.data ?? {}) as unknown as D;
  });

  protected _context = computed<IModalContext>(() => {
    return this.modalRef()?.context ?? {};
  });
}
